import React from "react";
import BusinessCont from "../../../sections/BusinessDashboard/Settings/BusinessCont";
import { AdminPageTitle } from "../../../sections/AdminDashboard/shared/adminUx";
import DashboardMainContainer from "../../../components/common/Containers/DashboardMainContainer";
import { BUSINESS_CENTERED_PAGE_TITLE_CLASS } from "../../../sections/BusinessDashboard/shared/businessLayoutSpec";

const BusinessContact = () => {
  return (
    <DashboardMainContainer className="lg:px-5 lg:pb-10">
      <AdminPageTitle className={`text-offblack ${BUSINESS_CENTERED_PAGE_TITLE_CLASS}`}>
        Update business contact details
      </AdminPageTitle>
      <div className="min-h-screen">
        <BusinessCont />
      </div>
    </DashboardMainContainer>
  );
};

export default BusinessContact;
